import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { HTTPValidationError, ICreateQuery, IDeleteQuery, ISuccessfulResponse, IUpdateQuery } from '../types/Queries';
import { baseQuery } from './baseQuery';

export const milestoneQueryApi = createApi({
  baseQuery,
  reducerPath: 'milestoneQueryApi',
  endpoints: builder => ({
    createMilestoneQuery: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
        data: ICreateQuery;
      }
    >({
      query: ({ site_id, study_id, country, application, application_section, data }) => ({
        url: formatString(
          endPoints.MilestoneQueries.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section }
        ),
        method: 'POST',
        body: data
      })
    }),
    getMilestoneQueries: builder.query<
      ICreateQuery,
      {
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
      }
    >({
      query: ({ site_id, study_id, country, application, application_section }) => ({
        url: formatString(
          endPoints.MilestoneQueries.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section }
        ),
        method: 'GET'
      })
    }),
    updateMilestoneQuery: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
        data: IUpdateQuery;
      }
    >({
      query: ({ site_id, study_id, country, application, application_section, data }) => ({
        url: formatString(
          endPoints.MilestoneQueries.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: urlKeys.application_section, value: application_section }
        ),
        method: 'PUT',
        body: data
      })
    }),
    deleteMilestoneQuery: builder.mutation<
      ISuccessfulResponse | HTTPValidationError,
      {
        site_id: string;
        study_id: string;
        country: string;
        application: string | undefined;
        application_section: string | undefined;
        data: IDeleteQuery;
      }
    >({
      query: ({ site_id, study_id, country, application, application_section, data }) => ({
        url: formatString(
          endPoints.MilestoneQueries.delete,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application },
          { key: application_section, value: application_section }
        ),
        method: 'PATCH',
        body: data
      })
    })
  })
});

export const {
  useCreateMilestoneQueryMutation,
  useDeleteMilestoneQueryMutation,
  useGetMilestoneQueriesQuery,
  useUpdateMilestoneQueryMutation
} = milestoneQueryApi;
